module.exports = __webpack_public_path__ + "static/media/voltgroom-replacement-blade-5.e69ba2b4.png";